export const platformOptions = [
  { value: 'mobile', text: 'Mobile' },
  { value: 'pc', text: 'PC' },
  { value: 'console', text: 'Console' },
];
